import React from 'react'; 
import './About.css';

import { Heading, Button } from '../../../components';
import { about } from '../../../constants';


const About = () => {   

  const { sub, heading, important, description, image, button } = about;

  return (
    <section className='about' id='about'>

      <Heading title={sub} />

      <div className='box-container'>

        {/* About Image */}
        <div className='image'>
          <img src={image.src} alt={image.alt} />
        </div>

        {/* Introduction Content */}
        <div className='content'>

          {/* Section Heading */}
          <h2>{heading}</h2>

          {/* Important Paragraph */}
          <h5>{important}</h5>

          {/* Description */}
          {description.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}

          {/* Button Component: Links to a specific page or action */}
          <Button link={button.link} title={button.text} />

        </div>
 
      </div> 

    </section>
  )
}

export default About;